import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import React from 'react';
import { Link } from 'react-router-dom';

interface IAlerts {
  adding?: boolean;
  closeModal?: () => void;
}

export const IdentityNotUploadedAlert = (props: IAlerts) => (
  <Alert type={AlertType.warning}>
    <div>
      <h3>Please upload proof of identity.</h3>
      <p>
        Before {props.adding ? 'adding' : 'applying for'} a registration number,
        you must{' '}
        <Link
          to={{
            pathname: '/profile',
            hash: '#identity-verification',
          }}
          onClick={props.closeModal}
        >
          upload proof of your identity
        </Link>
        .
      </p>
    </div>
  </Alert>
);

export const MailingAddressNotCompleteAlert = (props: IAlerts) => (
  <Alert type={AlertType.warning}>
    <div>
      <h3>Please complete your profile address.</h3>
      <p>
        Before {props.adding ? 'adding' : 'applying for'} a registration number,
        you must{' '}
        <Link
          to={{
            pathname: '/profile',
            hash: '#contact-information',
          }}
          onClick={props.closeModal}
        >
          complete your profile address
        </Link>
        .
      </p>
    </div>
  </Alert>
);

export const IdentityDeniedAlert = (props: IAlerts) => (
  <Alert type={AlertType.danger}>
    <div>
      <h3>
        Your proof of identity has been rejected. Please re-submit proof of
        identity
      </h3>
      <p>
        Before {props.adding ? 'adding' : 'applying for'} a registration number,
        you must{' '}
        <Link
          to={{
            pathname: '/profile',
            hash: '#identity-verification',
          }}
          onClick={props.closeModal}
        >
          re-submit your identity
        </Link>
        .
      </p>
    </div>
  </Alert>
);
